<template>
  <div class="toolbox-color" @click="setCanvasToolColor">
    <div class="inner-color" :style="'background-color:' + boxCanvasToolColor"></div>
  </div>
</template>
<script>
export default {
  name: 'tr-toolbox-color',
  props: {
    color: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    imagePath(iconId) {
      let images = require.context('../../../../../assets/icons/book/toolbox/', false, /\.png$/);
      return images('./' + iconId + '.png');
    },
    setCanvasToolColor(textMarker = false) {
      console.log(' this.color', this.color);
      this.$store.commit('CHANGE_CANVAS_TOOL_COLOR', this.color);
    },
  },
  computed: {
    isColorActive() {
      return this.$store.getters.toolColor === this.color ? true : false;
    },
    boxCanvasToolColor() {
      return this.color;
    },
    canvasToolColor() {
      return this.$store.getters.toolColor;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
.selected-color {
  .toolbox-color {
    width: $toolboxBigIcon;
    height: $toolboxBigIcon;
    cursor: pointer;
    .inner-color {
      width: $toolboxBigIcon * 80/100;
      height: $toolboxBigIcon * 80/100;
      background-size: contain;
      background-repeat: no-repeat;
      -webkit-font-smoothing: subpixel-antialiased;
      backface-visibility: hidden;
    }
  }
}
.toolbox-color {
  width: $toolboxSmallIcon;
  height: $toolboxSmallIcon;
  cursor: pointer;
  .inner-color {
    border: 1px solid black;
    width: ($toolboxSmallIcon * 80/100) - 2;
    height: ($toolboxSmallIcon * 80/100) - 2;
    background-size: contain;
    background-repeat: no-repeat;
    -webkit-font-smoothing: subpixel-antialiased;
    backface-visibility: hidden;
  }
}
.toolbox-color.activeColor {
  box-shadow: inset 0 0 6px $canvasActive;
}
</style>
